import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

import { MaintenanceLockComponent } from '@mp/system/maintenance/ui';

import { MaintenanceLockDialogData } from '../../models';

@Component({
  selector: 'mps-maintenance-lock-dialog',
  templateUrl: './maintenance-lock-dialog.component.html',
  styleUrl: './maintenance-lock-dialog.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [MaintenanceLockComponent],
})
export class MaintenanceLockDialogComponent {
  protected readonly data: MaintenanceLockDialogData = inject<MaintenanceLockDialogData>(MAT_DIALOG_DATA);
}
